import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2965_21586)">
      <path
        d="M5.58333 8H4.375C3.7086 8 3.16667 8.54194 3.16667 9.20833V10.4167C3.16667 11.0831 3.7086 11.625 4.375 11.625H5.58333C6.24973 11.625 6.79167 11.0831 6.79167 10.4167V9.20833C6.79167 8.54194 6.24973 8 5.58333 8ZM4.375 10.4167V9.20833H5.58333V10.4167H4.375ZM12.2292 1.95833H11.625V1.35417C11.625 1.02067 11.3549 0.75 11.0208 0.75C10.6867 0.75 10.4167 1.02067 10.4167 1.35417V1.95833H5.58333V1.35417C5.58333 1.02067 5.31327 0.75 4.97917 0.75C4.64506 0.75 4.375 1.02067 4.375 1.35417V1.95833H3.77083C2.10515 1.95833 0.75 3.31348 0.75 4.97917V12.2292C0.75 13.8949 2.10515 15.25 3.77083 15.25H12.2292C13.8949 15.25 15.25 13.8949 15.25 12.2292V4.97917C15.25 3.31348 13.8949 1.95833 12.2292 1.95833ZM3.77083 3.16667H12.2292C13.2285 3.16667 14.0417 3.97988 14.0417 4.97917V5.58333H1.95833V4.97917C1.95833 3.97988 2.77154 3.16667 3.77083 3.16667ZM12.2292 14.0417H3.77083C2.77154 14.0417 1.95833 13.2285 1.95833 12.2292V6.79167H14.0417V12.2292C14.0417 13.2285 13.2285 14.0417 12.2292 14.0417Z"
        fill="#151718"
      />
    </g>
    <defs>
      <clipPath id="clip0_2965_21586">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ScheduleIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default ScheduleIcon;
